export default function (...args)
{
	return {
		regex: /^(\d{8,14}|SEM GTIN)$/,
		filter: /[]/g,
	};
}

